const formatServiceDuration = (duration) => {
  if (typeof duration === "number") {
    return `${duration} min`;
  }

  return duration;
};

export default formatServiceDuration;
